import { useMutation } from "react-query";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

interface UpdateFeatureDetails {
  projectId: string;
  featureId: string;
  enabled?: boolean;
  dynamic?: boolean;
}

const updateFeatureDetails = async (payload: UpdateFeatureDetails) => {
  try {
    const url = paths.updateFeatureDetails();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useUpdateFeatureDetails = () => {
  return useMutation(updateFeatureDetails);
};
